////// Lib. //////
//////////////////

// ...

///// Util. //////
//////////////////

// ...

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. mobile slider"],
  end: ["init. mobile slider", "init. success"],
};

/// Init. def. ///
//////////////////

export default function init_mobileSlider() {
  ///// Setup //////
  //////////////////

  // const el_comp = this.element;
  const { wrpr_mobSlides, slides, btn_prev, btn_next, paginationDots } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  // flkty. init. //
  //////////////////

  const inst_flkty = new Flickity(wrpr_mobSlides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: true,
    cellAlign: "center",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    draggable: true,
    imagesLoaded: true,
    on: {
      ///// Ready //////
      //////////////////

      ready: () => {
        // Adjust slide height to match tallest slide
        const h_tallest = Math.max(...slides.map((s) => s.getBoundingClientRect().height));
        slides.forEach((s) => (s.style.height = `${h_tallest}px`));
      },

      // Slide change //
      //////////////////

      change: (i_activeSlide) => {
        // Pagination updt. //
        if (paginationDots) paginationDots.forEach((dot, i) => (dot.dataset.active = i === i_activeSlide ? "true" : "false"));
      },
    },
  });

  // Ctrl. init. ///
  //////////////////

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flkty.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flkty.next());

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
